<template>
  <v-container app :fluid="true" class="pt-0">
    <v-row>
      <v-col cols="6">
        <v-text-field
          v-model="search"
          append-icon="fas fa-search"
          label="Buscar producto"
          hide-details
          solo
          dense
          class="wost-text-input"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-btn
          class="float-right"
          dark
          color="primary"
          :disabled="showButtonSave"
          @click="handleSaveStock"
        >
          Guardar Stock Nuevo
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pb-0">
        <v-card>
          <template>
            <v-row>
              <v-col cols="12" class="pb-0">
                <v-data-table
                  class="wost-table"
                  :headers="headers"
                  :items="inventories"
                  item-key="id"
                  :search="search"
                  height="65vh"
                  fixed-header
                >
                  <template v-slot:item.barcode="{ item }">
                    <span v-if="item.barcode">
                      {{ item.barcode }}
                    </span>
                    <v-icon
                      v-if="item.barcode"
                      class="ml-2"
                      color="blue darken-1"
                      size="18"
                      @click="handlePrinBarcode(item)"
                    >
                      fas fa-barcode
                    </v-icon>
                  </template>

                  <template v-slot:item.product_cost="{ item }">
                    {{ (item.stock * item.product_cost) | currency("S/") }}
                  </template>

                  <template v-slot:item.new_stock="{ item }">
                    <v-text-field
                      :value="item.new_stock"
                      type="number"
                      outlined
                      dense
                      hide-details
                      class="input-stock float-right"
                      @focus="handleFocusNewStock(item)"
                      @input="handleInputNewStock"
                    ></v-text-field>
                  </template>
                  <template v-slot:item.action="{ item }">
                    <v-btn
                      small
                      @click="handleViewKardex(item)"
                      dark
                      color="grey darken-1"
                    >
                      Kardex
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </template>
        </v-card>
      </v-col>
    </v-row>
    <Locked ref="locked"></Locked>
    <print-barcode ref="printBarcode"></print-barcode>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import router from "@/router/index";

import Locked from "../../components/auth/Locked";
import Tools from "../../helpers/Tools";
import PrintBarcode from "../../components/Product/PrintBarcode";

export default {
  name: "InventoriesProducts",
  components: {
    PrintBarcode,
    Locked,
  },
  data() {
    return {
      search: null,
      search_name: null,
      new_stocks: [],
      headers: [
        {
          text: "PRODUCTO",
          value: "name",
          align: "left",
          sortable: false,
          class: "header-table",
        },
        {
          text: "CÓDIGO DE BARRAS",
          value: "barcode",
          align: "left",
          sortable: false,
          class: "header-table",
        },
        {
          text: "UND. DE MEDIDA",
          value: "unit_name",
          align: "left",
          sortable: false,
          class: "header-table",
        },
        {
          text: "STOCK",
          value: "stock",
          align: "end",
          sortable: false,
          class: "header-table",
          width: 140,
        },
        {
          text: "VALORIZADO",
          value: "product_cost",
          align: "end",
          sortable: false,
          class: "header-table",
          width: 140,
        },
        {
          text: "STOCK NUEVO",
          value: "new_stock",
          align: "end",
          sortable: false,
          class: "header-table",
          width: 140,
        },
        {
          text: "Acciones",
          value: "action",
          sortable: false,
          class: "header-table",
          width: 35,
        },
      ],
    };
  },
  computed: {
    ...mapState("general", ["name_section"]),
    ...mapState("products", ["products"]),
    ...mapState("inventories", [
      "inventories",
      "product_selected",
      "inventory_selected",
      "inventory_response",
    ]),
    showButtonSave() {
      let hideButton = true;
      let numberItemsModified = 0;
      this.inventories.forEach((element) => {
        if (parseFloat(element.new_stock) > 0) {
          numberItemsModified++;
        }
      });
      if (numberItemsModified > 0) {
        hideButton = false;
      }
      return hideButton;
    },
  },
  methods: {
    ...mapActions("authentication", ["run_set_locked"]),
    ...mapActions("general", ["setNameSection"]),
    ...mapActions("products", ["getAllProducts"]),
    ...mapActions("inventories", [
      "getInventory",
      "store",
      "setProductSelected",
      "setInventorySelected",
      "replaceInventoryItem",
    ]),
    handleViewKardex(inventory) {
      this.setNameSection("Kardex de productos");
      this.setProductSelected(inventory);
      this.setInventorySelected(inventory);
      router.push("/products-kardex");
    },
    async loadData() {
      await this.getInventory();
      this.run_set_locked(true);
      this.$refs.locked.show();
    },
    async handleSaveStock() {
      let new_inventory = [];
      this.inventories.forEach((element) => {
        if (parseFloat(element.new_stock) > 0) {
          new_inventory.push(element);
        }
      });
      let data = {
        inventories: new_inventory,
      };
      await this.store(data);
      if (this.inventory_response) {
        if (this.inventory_response == "error") {
          this.$notify({
            group: "foo",
            type: "error",
            title: "REGISTRO DE INVENTARIO",
            text: "Ocurrió un error al registrar inventario.",
          });
        } else {
          this.$notify({
            group: "foo",
            type: "success",
            title: "REGISTRO DE INVENTARIO",
            text: "Inventario registrado de forma correcta.",
          });
        }
      }
    },
    handleFocusNewStock(inventory) {
      this.setInventorySelected(inventory);
    },
    handleInputNewStock(new_stock) {
      let inventory = Object.assign({}, this.inventory_selected);
      if (!isNaN(new_stock) && new_stock !== null && new_stock !== "") {
        new_stock = parseFloat(new_stock);
      }
      inventory.new_stock = new_stock;
      this.updateRow(inventory);
    },
    updateRow(item) {
      let index = Tools.findIndexFromItem(this.inventories, item.id);
      if (index > -1) {
        this.replaceInventoryItem({
          index: index,
          item: item,
        });
      }
    },
    handlePrinBarcode(productItem) {
      console.log(productItem.name);
      let description = productItem.name;
      this.$refs.printBarcode.show(productItem, description);
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style scoped>
.input-stock {
  width: 80px !important;
  min-height: 25px !important;
}
</style>
